import { CheckboxInput } from "components/Form/CheckboxInput";
import Loader from "components/Loader";
import Joi from "joi";
import { omit } from "lodash";
import Link from "next/link";
import React from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { AppState } from "../../redux/store";
import AutoFillSelector from "./AutoFillSelector";
import Field from "./Fields/Field";
import { AutoFillProps, useAutoFill } from "./hooks";

const FormFieldsWrapper = styled.div`
    margin: 0.5rem 0;
`;

interface Props extends AutoFillProps {
    withoutLegal?: boolean;
}

const FormFields = (props: Props) => {
    const { isLoading, isLoadingAdditionalData, additionalData } = useAutoFill(omit(props, ["withoutLegal"]));
    const { fields = [], namePrefix = "formData", withoutLegal = false } = props;

    return (
        <Loader isLoading={isLoading}>
            <FormFieldsWrapper>
                <AutoFillSelector isLoading={isLoadingAdditionalData} additionalData={additionalData} />
                {fields.map((field) => (
                    <div key={field.name} className="tw-mb-3">
                        <Field namePrefix={namePrefix} field={field} />
                    </div>
                ))}
                <small className="text-muted mt-2">
                    <b>
                        <Trans ns="form">Legende</Trans>
                    </b>
                    {":* "}
                    <Trans ns="form">bezeichnet ein Pflichtfeld</Trans>
                </small>
                {!withoutLegal && <LegalFields />}
            </FormFieldsWrapper>
        </Loader>
    );
};

const LegalFields = () => {
    const { isAuthenticated, isLoading } = useSelector((state: AppState) => state.auth);

    return (!isAuthenticated &&
        !isLoading && (<div className="my-3">
            <CheckboxInput
                schema={Joi.boolean()
                    .required()
                    .valid(true)
                    .messages({
                        ["any.only"]: "***Du musst den AGB von Sportision zustimmen um Anmeldung abzuschließen.",
                    })}
                name="sportision_legal_agb"
                label={
                    <>
                        <Trans ns="form">
                            Ich bestätige, dass ich die AGB von Sportision gelesen habe und akzeptiere diese.
                        </Trans>
                        *
                        <br />
                        <Link href="/agb" target="_blank">

                            <Trans ns="common">AGB</Trans>

                        </Link>
                    </>
                }
                omit
            />
            <CheckboxInput
                schema={Joi.boolean()
                    .required()
                    .valid(true)
                    .messages({
                        ["any.only"]:
                            "***Du musst den Datenschutzrichtlinien von Sportision zustimmen um Anmeldung abzuschließen.",
                    })}
                name="sportision_legal_dsgvo"
                label={
                    <>
                        <Trans ns="form">
                            Ich bestätige, dass ich die Datenschutzrichtlinien von Sportision gelesen habe und
                            akzeptiere diese.
                        </Trans>
                        *
                        <br />
                        <Link href="/datenschutz" target="_blank">

                            <Trans ns="common">Datenschutzrichtlinien</Trans>

                        </Link>
                    </>
                }
                omit
            />
        </div>));
};
export default FormFields;
